import { writable } from 'svelte/store';
import { persisted } from 'svelte-persisted-store';

/**
 * Safely creates a persisted store with fallback to regular writable store
 * if localStorage is not available (e.g., Safari private mode, cross-origin iframes,
 * in-app browsers that deny storage access and throw a SecurityError on read)
 *
 * @param key - The localStorage key to use
 * @param initialValue - The initial value for the store
 * @returns A persisted store or writable store if localStorage is unavailable
 */
export const safePersistedStore = <T>(key: string, initialValue: T) => {
	try {
		// Test if localStorage is accessible
		if (typeof window !== 'undefined' && window.localStorage) {
			// Try to access localStorage to trigger SecurityError if it's restricted
			window.localStorage.getItem(key);
			return persisted(key, initialValue);
		}
	} catch (error) {
		console.warn(`localStorage not available for key "${key}", using in-memory store:`, error);
	}
	// Fallback to regular writable store if localStorage is not available
	return writable(initialValue);
};
